/**
 * Creates a method to compatible with Array.sort() to sort an array of objects by one or more keys.
 * @param keys Either a key (sorted ascending)
 *  or a key and number indicating direction ['key', 0] (> 0 is ascending, < 0 is descending)
 * @returns The method to provide to the .sort() to perform the sort.
 * @example arr.sort(sortBy('key') // dir === 1
 * @example arr.sort(sortBy(['key', -1]))
 */
export function sortBy<T extends Partial<Record<K, unknown>>, K extends keyof T>(...keys:(K | [key: K, dir:number])[]): (a: T, b: T) => number {
  return (a: T, b: T): number =>
    keys.map(input => {
      let key: K;
      let dir = 1; // ascending

      if (Array.isArray(input)) {
        [key, dir] = input;
      } else if (typeof input === 'string') {
        key = input;
      } else {
        throw new Error(`Invalid key: ${String(input)}`);
      }

      return ((a[key] as string)?.toLowerCase?.() ?? a[key]) < ((b[key] as string)?.toLowerCase?.() ?? b[key])
        ? -dir
        : ((b[key] as string)?.toLowerCase?.() ?? b[key]) < ((a[key] as string)?.toLowerCase?.() ?? a[key])
          ? dir
          : 0
    }).find(r => r) || 0;
}

[{ a: 1 }, { a: 2 }, { a: 3 }]
  .sort(sortBy('a'));

[{ a: 1 }, { a: 2 }, { a: 3 }]
  .sort(sortBy(['a', -1]));